import { render, staticRenderFns } from "./TheFullPageLayout.vue?vue&type=template&id=25bdc8d0&scoped=true&"
import script from "./TheFullPageLayout.vue?vue&type=script&lang=js&"
export * from "./TheFullPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheFullPageLayout.vue?vue&type=style&index=0&id=25bdc8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bdc8d0",
  null
  
)

export default component.exports